import React, { Component } from 'react';
import SectionFooter from '../../components/views/SectionFooter';
import CheckboxInput from '../../components/inputs/checkboxInput';
import InputField from '../../components/inputs/inputField';
import API from '../../utils/API';

const concessionOptions = [
	'Comp Room Ratio (ideally comp 1:40)',
	'Discounted or waived resort/destination fees',
	'Discounted or complimentary wifi and hardline internet',
	'Cumulative Attrition, 20%',
	'Discounted F&B (minimum 10%)',
	'Staff and VIP Upgrades',
	'Discounted or waived parking (self and valet parking)',
	'Resale and Rebooking Clauses',
	'Multi year rebates',
	'Discounted or waived AV and Branding Fees',
	'No Walk Clause',
	'Waive room rental with F&B achievement'
];

class Concessions extends Component {
	constructor(props) {
		super(props);
		const { venue } = props;
		
		this.state = {
			concessions: venue.concessions || [],
			customConcession: '',
			editing: false,
			saving: false
		};
	}

	toggleConcession = (concessionType) => {
		const { concessions } = this.state;
		const existing = concessions.find(c => c.type === concessionType);
		
		if (existing) {
			const updated = concessions.filter(c => c.type !== concessionType);
			this.setState({ concessions: updated, editing: true });
		} else {
			concessions.push({ type: concessionType, customValue: '' });
			this.setState({ concessions, editing: true });
		}
	};

	updateConcessionValue = (concessionType, value) => {
		const { concessions } = this.state;
		const concession = concessions.find(c => c.type === concessionType);
		if (concession) {
			concession.customValue = value;
			this.setState({ concessions, editing: true });
		}
	};

	addCustomConcession = () => {
		const { concessions, customConcession } = this.state;
		
		if (customConcession.trim()) {
			concessions.push({
				type: 'Custom',
				customValue: customConcession.trim()
			});
			this.setState({ concessions, customConcession: '', editing: true });
		}
	};

	removeCustomConcession = (index) => {
		const { concessions } = this.state;
		concessions.splice(index, 1);
		this.setState({ concessions, editing: true });
	};

	saveDetails = async () => {
		this.setState({ saving: true });
		
		try {
			await API().patch(
				`Organizations/${this.props.orgId}/sourced-venues/${this.props.venueId}`,
				{ concessions: this.state.concessions }
			);
			
			this.setState({ editing: false, saving: false });
			this.props.refreshSectionCounts && this.props.refreshSectionCounts();
		} catch (error) {
			console.error('Error saving concessions:', error);
			this.setState({ saving: false });
		}
	};

	cancelEdit = () => {
		const { venue } = this.props;
		this.setState({
			concessions: venue.concessions || [],
			customConcession: '',
			editing: false
		});
	};

	render() {
		const { concessions, customConcession, editing } = this.state;
		const { venue } = this.props;
		
		const customConcessions = concessions.filter(c => c.type === 'Custom');
		
		return (
			<>
				<div className="sectionBody">
					<div className="sectionBlock">
						<h2 className="blockHeader">Required Concessions</h2>
						<p className="grey mb-20">Select all concessions that are important for your event</p>
						
						<div className="flex flex-wrap" style={{ gap: '15px' }}>
							{concessionOptions.map((concession) => {
								const isSelected = concessions.some(c => c.type === concession);
								const selectedConcession = concessions.find(c => c.type === concession);
								
								return (
									<div key={concession} style={{ flex: '0 0 100%', minWidth: '300px' }}>
										<CheckboxInput
											label={concession}
											checked={isSelected}
											onChange={() => this.toggleConcession(concession)}
										/>
										{isSelected && selectedConcession && (
											<div className="ml-30 mt-10 mb-10">
												<InputField
													label="Additional Details (optional)"
													value={selectedConcession.customValue}
													onChange={(e) => this.updateConcessionValue(concession, e.target.value)}
													placeholder="Add specific requirements or details..."
												/>
											</div>
										)}
									</div>
								);
							})}
						</div>
					</div>
					
					<div className="sectionBlock">
						<h2 className="blockHeader">Custom Concessions</h2>
						<p className="grey mb-20">Add any additional concessions not listed above</p>
						
						<div className="flex aic mb-20">
							<InputField
								label="Custom Concession"
								value={customConcession}
								onChange={(e) => this.setState({ customConcession: e.target.value })}
								placeholder="Enter custom concession requirement..."
							/>
							<button 
								className="neu min ml-10 mt-15" 
								onClick={this.addCustomConcession}
								disabled={!customConcession.trim()}
							>
								<i className="las la-plus mr-10" />
								Add
							</button>
						</div>
						
						{customConcessions.length > 0 && (
							<div>
								<h3 className="mb-15">Added Custom Concessions:</h3>
								{customConcessions.map((concession, index) => (
									<div key={index} className="neuCard p-15 mb-10 flex aic jcsb">
										<span>{concession.customValue}</span>
										<button
											className="p-7"
											onClick={() => {
												const actualIndex = concessions.indexOf(concession);
												this.removeCustomConcession(actualIndex);
											}}
										>
											<i className="las la-trash-alt" style={{ color: 'red' }} />
										</button>
									</div>
								))}
							</div>
						)}
					</div>
				</div>
				<SectionFooter
					saveEdit={this.saveDetails}
					cancelEdit={this.cancelEdit}
					updatedAt={venue.updatedAt}
					editing={editing}
				/>
			</>
		);
	}
}

export default Concessions;
